<template>
  <div class="meet-room">
    <!-- Remotos -->
    <div class="remote-grid" :class="{ 'has-remote': hasRemote }">
      <div v-for="(stream, id) in remoteStreams" :key="id" class="remote-box">
        <video
          autoplay
          playsinline
          :ref="'remote_' + id"
          class="video-box"
        ></video>
        <div class="username">Usuário: {{ participantName }}</div>
      </div>
    </div>
    <canvas ref="recordCanvas" class="record-canvas"></canvas>

    <!-- Local -->
    <div class="local-video" :class="hasRemote ? 'small' : 'centered'">
      <!-- <div class="local-video" :class="{ 'small': hasRemote, 'centered': !hasRemote }"> -->
      <video
        ref="localVideo"
        autoplay
        muted
        playsinline
        class="video-box"
      ></video>
    </div>

    <div class="controls">
      <b-button
        class="control-btn"
        :class="{ active: !micOn }"
        @click="toggleMic"
        >🎤</b-button
      >

      <b-button
        class="control-btn"
        :class="{ active: !camOn }"
        @click="toggleCam"
        >🎥</b-button
      >

      <b-button
        class="control-btn"
        :class="{ active: isRecording }"
        @click="toggleRecording"
        >⏺️</b-button
      >

      <b-button class="control-btn" @click="shareScreen">🖥️</b-button>

      <b-button class="control-btn end-call" @click="leaveRoom">📞</b-button>
    </div>
  </div>
</template>

<script>
import io from 'socket.io-client';

export default {
  props: {
    roomId: {
      type: String,
      required: true,
    },
    participantName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      socket: null,
      //   roomId: this.$route.params.roomId || 'teste',
      localStream: null,
      peerConnections: {},
      remoteStreams: {},
      micOn: true,
      camOn: true,
      recording: false,
      mediaRecorder: null,
      recordedChunks: [],

      // 🔴 novos
      recordingStream: null,
      audioContext: null,
      audioDestination: null,

      canvas: null,
      ctx: null,
      canvasStream: null,
      drawInterval: null,

      activeScreenStream: null,
      activeScreenUser: null,
    };
  },

  computed: {
    hasRemote() {
      return Object.keys(this.remoteStreams).length > 0;
    },
  },

  async mounted() {
    await this.startLocalStream();
    this.initSocket();
  },

  methods: {
    initCanvas() {
      this.canvas = this.$refs.recordCanvas;
      this.canvas.width = 1280;
      this.canvas.height = 720;
      this.ctx = this.canvas.getContext('2d');
    },
    drawGrid() {
      const videos = [];

      // local
      if (this.$refs.localVideo) {
        videos.push(this.$refs.localVideo);
      }

      // remotos
      Object.keys(this.remoteStreams).forEach((id) => {
        const ref = this.$refs['remote_' + id];
        const video = Array.isArray(ref) ? ref[0] : ref;
        if (video) videos.push(video);
      });

      const count = videos.length;
      if (count === 0) return;

      const cols = Math.ceil(Math.sqrt(count));
      const rows = Math.ceil(count / cols);

      const w = this.canvas.width / cols;
      const h = this.canvas.height / rows;

      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

      videos.forEach((video, index) => {
        const x = (index % cols) * w;
        const y = Math.floor(index / cols) * h;

        // this.ctx.drawImage(video, x, y, w, h)
        this.drawVideoContain(video, x, y, w, h);
      });
    },
    

    drawVideoContain(video, x, y, w, h) {
      const videoRatio = video.videoWidth / video.videoHeight;
      const boxRatio = w / h;

      let drawWidth, drawHeight, offsetX, offsetY;

      if (videoRatio > boxRatio) {
        drawWidth = w;
        drawHeight = w / videoRatio;
        offsetX = x;
        offsetY = y + (h - drawHeight) / 2;
      } else {
        drawHeight = h;
        drawWidth = h * videoRatio;
        offsetX = x + (w - drawWidth) / 2;
        offsetY = y;
      }

      this.ctx.drawImage(video, offsetX, offsetY, drawWidth, drawHeight);
    },

    startCanvasDraw() {
      this.drawInterval = setInterval(() => {
        this.drawGrid();
      }, 1000 / 30);
    },

    stopCanvasDraw() {
      clearInterval(this.drawInterval);
    },
    createRecordingStream() {
      this.recordingStream = new MediaStream();

      // 🎧 Áudio mixado
      this.audioContext = new AudioContext();
      this.audioDestination = this.audioContext.createMediaStreamDestination();

      // adiciona track de áudio mixado
      this.audioDestination.stream
        .getTracks()
        .forEach((track) => this.recordingStream.addTrack(track));
    },

    addAudioToRecording(stream) {
      if (!this.audioContext) return;

      const source = this.audioContext.createMediaStreamSource(stream);
      source.connect(this.audioDestination);
    },

    addVideoToRecording(stream) {
      stream.getVideoTracks().forEach((track) => {
        this.recordingStream.addTrack(track);
      });
    },

    toggleRecording() {
      if (this.recording) {
        this.mediaRecorder.stop();
        this.stopCanvasDraw();
        this.recording = false;
        return;
      }

      this.initCanvas();
      this.startCanvasDraw();

      // captura vídeo do canvas
      this.canvasStream = this.canvas.captureStream(30);

      // 🎧 MIX DE ÁUDIO
      this.audioContext = new AudioContext();
      this.audioDestination = this.audioContext.createMediaStreamDestination();

      // local
      this.addAudioToRecording(this.localStream);

      // remotos
      Object.values(this.remoteStreams).forEach((stream) => {
        this.addAudioToRecording(stream);
      });

      // adiciona áudio ao canvas stream
      this.audioDestination.stream.getTracks().forEach((track) => {
        this.canvasStream.addTrack(track);
      });

      this.recordedChunks = [];
      this.mediaRecorder = new MediaRecorder(this.canvasStream, {
        mimeType: 'video/webm; codecs=vp9,opus',
      });

      this.mediaRecorder.ondataavailable = (e) => {
        if (e.data.size > 0) this.recordedChunks.push(e.data);
      };

      this.mediaRecorder.onstop = () => {
        const blob = new Blob(this.recordedChunks, { type: 'video/webm' });
        const url = URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download = `reuniao-${this.roomId}.webm`;
        a.click();
        URL.revokeObjectURL(url);
      };

      this.mediaRecorder.start();
      this.recording = true;
    },

    getAllVideos() {
      const videos = [];

      // Screen share primeiro (se existir)
      if (this.activeScreenStream) {
        videos.push({
          type: 'screen',
          video: this.getVideoElementFromStream(this.activeScreenStream),
        });
      }

      // Remotos
      Object.entries(this.remoteStreams).forEach(([id, stream]) => {
        console.log(id)
        if (stream !== this.activeScreenStream) {
          videos.push({
            type: 'camera',
            video: this.getVideoElementFromStream(stream),
          });
        }
      });

      // Local
      videos.push({
        type: 'camera',
        video: this.$refs.localVideo,
      });

      return videos;
    },
    

    calculateLayout(videos) {
      const w = this.canvas.width;
      const h = this.canvas.height;

      // 🎥 SCREEN SHARE ATIVO
      if (videos[0]?.type === 'screen') {
        const sidebarWidth = Math.floor(w * 0.25);
        const mainWidth = w - sidebarWidth;

        const layouts = [];

        // Tela compartilhada (grande)
        layouts.push({
          x: 0,
          y: 0,
          w: mainWidth,
          h,
        });

        // Participantes na lateral
        const sideVideos = videos.slice(1);
        const tileHeight = h / sideVideos.length;

        sideVideos.forEach((_, i) => {
          layouts.push({
            x: mainWidth,
            y: i * tileHeight,
            w: sidebarWidth,
            h: tileHeight,
          });
        });

        return layouts;
      }

      // 🔹 SEM SCREEN SHARE → GRID NORMAL
      return this.calculateGrid(videos.length);
    },

    leaveRoom() {
      this.$emit('leave');

      // Para todas as tracks locais
      if (this.localStream) {
        this.localStream.getTracks().forEach((track) => track.stop());
      }

      // Fecha todos os peer connections
      Object.values(this.peerConnections).forEach((pc) => pc.close());
      this.peerConnections = {};
      this.remoteStreams = {};

      // Desconecta o socket
      if (this.socket) this.socket.disconnect();

      // Redireciona para tela inicial
      //   this.$router.push('/');
    },
    async startLocalStream() {
      this.localStream = await navigator.mediaDevices.getUserMedia({
        video: true,
        audio: true,
      });
      this.$refs.localVideo.srcObject = this.localStream;
    },

    initSocket() {
      this.socket = io('https://apivtelemedicine.venxtecnologia.com.br', {
        transports: ['websocket'],
        secure: true,
      });
      this.socket.emit('join-room', this.roomId);

      this.socket.on('existing-users', (users) =>
        users.forEach((id) => this.createPeer(id, true))
      );
      this.socket.on('user-joined', (id) => this.createPeer(id, false));

      this.socket.on('signal', async ({ from, type, data }) => {
        const pc = this.peerConnections[from];
        if (!pc) return;
        if (type === 'offer') {
          await pc.setRemoteDescription(new RTCSessionDescription(data));
          const answer = await pc.createAnswer();
          await pc.setLocalDescription(answer);
          this.socket.emit('signal', {
            to: from,
            type: 'answer',
            data: answer,
          });
        } else if (type === 'answer') {
          await pc.setRemoteDescription(new RTCSessionDescription(data));
        } else if (type === 'ice') {
          try {
            await pc.addIceCandidate(data);
          } catch (e) {
            console.error(e);
          }
        }
      });

      this.socket.on('user-disconnected', (id) => {
        if (this.peerConnections[id]) {
          this.peerConnections[id].close();
          delete this.peerConnections[id];
          this.$delete(this.remoteStreams, id);
        }
      });
    },

    createPeer(userId, isInitiator) {
      const pc = new RTCPeerConnection({
        iceServers: [{ urls: 'stun:stun.l.google.com:19302' }],
      });
      this.localStream
        .getTracks()
        .forEach((track) => pc.addTrack(track, this.localStream));

      pc.onicecandidate = (event) => {
        if (event.candidate) {
          this.socket.emit('signal', {
            to: userId,
            type: 'ice',
            data: event.candidate,
          });
        }
      };

      //   pc.ontrack = (event) => {
      //     const stream = event.streams[0];
      //     this.$set(this.remoteStreams, userId, stream);
      //     this.$nextTick(() => {
      //       const refs = this.$refs['remote_' + userId];
      //       if (!refs) return;
      //       const videoEl = Array.isArray(refs) ? refs[0] : refs;
      //       videoEl.srcObject = stream;
      //       videoEl.play().catch(() => {});
      //     });
      //   };

      pc.ontrack = (event) => {
        const stream = event.streams[0];
        const track = event.track;
        this.$set(this.remoteStreams, userId, stream);

        // 🎥 vídeo na UI
        this.$nextTick(() => {
          const refs = this.$refs['remote_' + userId];
          if (!refs) return;
          const videoEl = Array.isArray(refs) ? refs[0] : refs;
          videoEl.srcObject = stream;
          videoEl.play().catch(() => {});
        });

        // 👇 DETECTA SCREEN SHARE
        if (
          track.kind === 'video' &&
          track.label.toLowerCase().includes('screen')
        ) {
          this.activeScreenStream = stream;
          this.activeScreenUser = userId;
        }

        // 🔴 SE ESTIVER GRAVANDO, ENTRA NA GRAVAÇÃO
        if (this.recording) {
          this.addAudioToRecording(stream);
          this.addVideoToRecording(stream);
        }
      };

      this.peerConnections[userId] = pc;
      if (isInitiator) {
        pc.createOffer().then((offer) => {
          pc.setLocalDescription(offer);
          this.socket.emit('signal', {
            to: userId,
            type: 'offer',
            data: offer,
          });
        });
      }
    },

    toggleMic() {
      this.micOn = !this.micOn;
      this.localStream
        .getAudioTracks()
        .forEach((track) => (track.enabled = this.micOn));
    },

    toggleCam() {
      this.camOn = !this.camOn;
      this.localStream
        .getVideoTracks()
        .forEach((track) => (track.enabled = this.camOn));
    },

    async shareScreen() {
      try {
        const screenStream = await navigator.mediaDevices.getDisplayMedia({
          video: true,
        });
        const screenTrack = screenStream.getTracks()[0];
        const senders = Object.values(this.peerConnections)
          .map((pc) => pc.getSenders().find((s) => s.track.kind === 'video'))
          .filter(Boolean);
        senders.forEach((s) => s.replaceTrack(screenTrack));
        this.$refs.localVideo.srcObject = screenStream;
        screenTrack.onended = () => {
          const camTrack = this.localStream.getVideoTracks()[0];
          senders.forEach((s) => s.replaceTrack(camTrack));
          this.$refs.localVideo.srcObject = this.localStream;
        };
      } catch (e) {
        console.error(e);
      }
    },
  },

  beforeDestroy() {
    if (this.socket) this.socket.disconnect();
    Object.values(this.peerConnections).forEach((pc) => pc.close());
  },
};
</script>

<style scoped>
.meet-room {
  position: relative;
  width: 100%;
  height: 100vh;
  background: #030b12;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Grid de remotos */
.remote-grid {
  display: grid;
  gap: 8px;
  padding: 8px;
  width: 100%;
  height: 100%;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  grid-auto-rows: minmax(200px, 1fr);
}

.remote-box {
  position: relative;
  width: 100%;
  height: 100%;
}

.video-box {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  background: #000;
  object-fit: cover;
}

.username {
  position: absolute;
  bottom: 4px;
  left: 8px;
  color: #fff;
  font-size: 12px;
  background: rgba(0, 0, 0, 0.4);
  padding: 2px 4px;
  border-radius: 4px;
}

/* Vídeo local sozinho - centralizado e proporcional */
.local-video {
  position: absolute;
  z-index: 5;
  display: flex;
  justify-content: center;
  align-items: center;
}

.local-video.centered {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80vw;
  height: 80vh;
  max-width: 1200px;
  max-height: 800px;
}

.local-video.centered video {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* Vídeo local pequeno quando há remotos */
.local-video.small {
  bottom: 16px;
  right: 16px;
  width: 200px;
  height: 150px;
}

.local-video.small video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Controles */
.controls {
  position: absolute;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 12px;
  z-index: 10;
}

.controls b-button {
  font-size: 18px;
  padding: 8px 12px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  border: none;
  cursor: pointer;
  transition: background 0.2s;
}

.controls b-button:hover {
  background: rgba(255, 255, 255, 0.2);
}

.controls .control-btn {
  background-color: #d3d3d3; /* cinza claro padrão */
  color: #202124;
  border: none;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  transition: background 0.2s, transform 0.2s;
}

/* Hover padrão */
.controls .control-btn:hover {
  background-color: #c0c0c0;
  transform: scale(1.1);
}

/* Botão ativo/desativado fica vermelho */
.controls .control-btn.active {
  background-color: #ff4b5c; /* vermelho Meet-like */
  color: #fff;
}

/* Botão de encerrar sempre vermelho */
.controls .control-btn.end-call {
  background-color: #ff3b30;
  color: #fff;
}

.controls .control-btn.end-call:hover {
  background-color: #e53935;
  transform: scale(1.1);
}
.record-canvas {
  display: none; /* não aparece na UI */
}
</style>
